export var PastInteractionColumn = [
    {
        columnName: "Assigned to name",
        key: "AssignedToName",
    },
    {
        columnName: "Task Type",
        key: "TypeOfContact",
    },
    {
        columnName: "Client Contacted",
        key: "IsClientContacted",
    },
    {
        columnName: "Source",
        key: "Source",
    },
    {
        columnName: "Priority",
        key: "Priority",
    },
    {
        columnName: "Status",
        key: "StatusName",
    },
    {
        columnName: "Bucket",
        key: "BucketName",
    },
    {
        columnName: "Product",
        key: "ProductName",
    },
    {
        columnName: "Category",
        key: "CategoryName",
    },
    {
        columnName: "Sub Category",
        key: "SubCategoryName",
    },
    {
        columnName: "TaskDescription",
        key: "TaskDescription",
    },
    {
        columnName: "Mandate Date",
        key: "DueDate",
    },
    {
        columnName: "Response",
        key: "Response",
    },
    {
        columnName: "Notes",
        key: "Notes",
    },
    {
        columnName: "Assigned Date",
        key: "CreatedDate",
    },
    {
        columnName: "Last Modified Date",
        key: "CloseDate",
    },
    {
        columnName: "Meeting Done Date",
        key: "MeetingClosureDate",
    },
];
export var PastInteractionRows = [
    {
        assigned: "Rahul Jain (2478)",
        tasktype: "Call",
        client: "Yes",
        source: "Special Events",
        priority: "High",
        status: "Not interested",
        bucket: "Product",
        product: "Life Insurance",
        category: "ULIP",
        subcategory: "Edelweiss Tokio Life- Wealth Plus",
        task: "TEST FLOW BRS",
    },
    {
        assigned: "Rahul Jain (2478)",
        tasktype: "Call",
        client: "Yes",
        source: "Special Events",
        priority: "High",
        status: "Not interested",
        bucket: "Product",
        product: "Life Insurance",
        category: "ULIP",
        subcategory: "Edelweiss Tokio Life- Wealth Plus",
        task: "TEST FLOW BRS",
    },
];
